import React, { useEffect } from 'react';
import Logo from './Logo';
import LanguageAndSocialLinks from './LanguageAndSocialLinks';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import './NavBar.css';

const NavBar = ({ isMobile, isMenuOpen, setIsMenuOpen }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const currentPath = window.location.pathname;

  const getLocalizedPath = (path) => `/${currentLanguage}${path}`;

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  useEffect(() => {
    if (!isMobile) {
      setIsMenuOpen(false);
    }
  }, [isMobile, setIsMenuOpen]);

  return (
    <div className="navbar-container">
      <nav className={`navbar ${isMenuOpen ? 'menu-open' : ''}`}>
        {isMobile ? (
          <div className="mobile-navbar">
            <div className="mobile-navbar-header">
              <div className="mobile-navbar-logo">
                <Logo />
              </div>
              <div className="mobile-navbar-hamburger">
                <FontAwesomeIcon
                  icon={faBars}
                  className="hamburger-icon"
                  onClick={toggleMenu}
                />
              </div>
            </div>
            {isMenuOpen && (
              <div className="mobile-menu">
                <ul className="mobile-navbar-links">
                  <li>
                    <a
                      href={getLocalizedPath('/home')}
                      className={currentPath === getLocalizedPath('/home') ? 'active' : ''}
                    >
                      {t('home')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={getLocalizedPath('/competition')}
                      className={currentPath === getLocalizedPath('/competition') ? 'active' : ''}
                    >
                      {t('competition')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={getLocalizedPath('/members')}
                      className={currentPath === getLocalizedPath('/members') ? 'active' : ''}
                    >
                      {t('membersNav')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={getLocalizedPath('/contact')}
                      className={currentPath === getLocalizedPath('/contact') ? 'active' : ''}
                    >
                      {t('contact')}
                    </a>
                  </li>
                </ul>
                <div className="mobile-language-social-links">
                  <LanguageAndSocialLinks />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="navbar-content">
            <a href={getLocalizedPath('/home')}>
              <div className="navbar-logo">
                <Logo id="navbar_logo" />
              </div>
            </a>
            <ul className="navbar-links">
              <li>
                <a
                  href={getLocalizedPath('/home')}
                  className={currentPath === getLocalizedPath('/home') ? 'active' : ''}
                >
                  {t('home')}
                </a>
              </li>
              <li>
                <a
                  href={getLocalizedPath('/competition')}
                  className={currentPath === getLocalizedPath('/competition') ? 'active' : ''}
                >
                  {t('competition')}
                </a>
              </li>
              <li>
                <a
                  href={getLocalizedPath('/members')}
                  className={currentPath === getLocalizedPath('/members') ? 'active' : ''}
                >
                  {t('membersNav')}
                </a>
              </li>
              <li>
                <a
                  href={getLocalizedPath('/contact')}
                  className={currentPath === getLocalizedPath('/contact') ? 'active' : ''}
                >
                  {t('contact')}
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
      {!isMobile && (
        <div className="language-container">
          <LanguageAndSocialLinks />
        </div>
      )}
    </div>
  );
};

export default NavBar;
